module.exports = __webpack_public_path__ + "static/media/DK_Poems.dbe893c6.png";